__webpack_require__.p = "https://asset-sandbox-core5.clickworker.com/assets/";__webpack_require__.p = "https://asset-sandbox-core5.clickworker.com/assets/";